var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Traker Spots","storeName":"Trakers_spot","parentStoreName":"Trakers","parentUrlKey":"spot_id","sortable":"","canSearch":"","canAdd":false,"canEdit":false,"canDelete":true,"labelBack":"Atrás","breadcrumbs":[
      {
        text: 'Reservas y estadías',
        disabled: false,
        href: '/admin/trakers'
      },
      {
        text: 'Traker Spots',
        disabled: false,
        href: '#'
      },
    ]},scopedSlots:_vm._u([{key:"driver",fn:function({ item }){return [_c('v-row',{staticClass:"pt-2 ms-1"},[_vm._v(" "+_vm._s(item.driver && item.driver.user ? ((item.driver.user.name || "") + " " + (item.driver.user.last_name || "")) : "")+" ")])]}},{key:"car",fn:function({ item }){return [_c('v-row',{staticClass:"pt-2 ms-1"},[_vm._v(" "+_vm._s(item.driver && item.driver.patent ? item.driver.patent : "")+" ")])]}},{key:"created_at",fn:function({ item }){return [_c('v-row',{staticClass:"pt-2 ms-1"},[_vm._v(" "+_vm._s(_vm.formatDateTimeUtc3(item.created_at))+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }